import {Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import {AccountService} from "../../services/account.service";
import {ErrorService} from "../../services/error.service";

@Component({
  selector: 'app-private-header',
  templateUrl: './private-header.component.html',
  styleUrls: ['./private-header.component.css']
})
export class PrivateHeaderComponent implements OnInit {

  isResident: boolean = false;
  triconDomain = environment.triconDomain;

  constructor(private accountService: AccountService,
              public router: Router,
              private errorService: ErrorService) { }

  triconPhone = environment.triconPhone;

  ngOnInit(): void {
    this.getResidentStatus();
  }

  getResidentStatus() {
    this.accountService.getResidentStatus2()
      .subscribe(res => this.onGetResidentStatusSuccess(res), err => this.onGetResidentStatusError(err));
  }
  onGetResidentStatusSuccess(isResident: boolean){
    this.isResident = isResident;
  }

  onGetResidentStatusError(msg: string){
    this.errorService.showError(msg)
  }

  callTricon() {
    if (isMobileDevice() == true) {
      window.location.href = 'tel:' + this.triconPhone;
    }

    function isMobileDevice() {
      return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    };
  }

  onFavoritesClick() {
    this.router.navigate(['/favorites/dashboard']);
  }
  onTourClick() {
    this.router.navigate(['/account/tours']);
  }
  onDashboardHomeClick() {
    this.router.navigate(['/application/dashboard']);
  }
  onAccountClick() {
    this.router.navigate(['/account/account-management']);
  }
  onSignOutClick() {
    localStorage.clear();
    this.router.navigate(['/logout']);
  }
}
